<script>
    export let realtors
    export let setOrderBy
    export let promise
    export let order_by

    let active = {
            btn1 : false,
            btn2 : false,
            btn3 : false
        }
</script>

<table id="realtors">
    <tr>
        <th>
            <button class="last_name asc" on:click={ (e) => setOrderBy(e) } >Name</button>
        <th>
            <button class="office_name desc" on:click={ (e) => setOrderBy(e) }>Office</button>
        </th>
        <th>
            <button class="office_address desc" on:click={ (e) => setOrderBy(e) }>Address</button>
        </th>
        <th>
            Email
        </th>
        <th>
            Realtor Profile
        </th>
    </tr>
    {#await promise}
    <tr>
        <td colspan="5" class="loader-wrapper" align="middle">
            <div class="loader">
                <div class="spinner"></div>
                One Moment. Loading...
            </div>
        </td>
    </tr>
    {:then realtors}
    {#if realtors.length > 0}
    
    {#each realtors as realtor}
    <tr>
        <td class="agent__name">
         {realtor.full_name} 
        </td>
        <td>
            {realtor.office_name}
        </td>
        <td>
            {realtor.office_address}<br>
            {realtor.office_city}, {realtor.office_zip}
        </td>
        <td>
            {#if realtor.hasOwnProperty('office_email') && realtor.office_email !== null}
                <a href="mailto:{realtor.office_email}">{realtor.office_email}</a>
            {/if}
        </td>
        <td>
            {#if realtor.hasOwnProperty('profile_url')}
                <a href="{realtor.profile_url}" target="_blank">View</a>
            {/if}
        </td>
    </tr>
    {/each}
    {:else}
    <tr>
        <td colspan="5" class="loader-wrapper">
            <div class="loader">
                No results found.
            </div>
        </td>
    </tr>
    {/if}
    {/await}
</table>


<style>
    
    table {
        width: 100%;
        border-bottom: solid 1px #ccc;
        border-collapse: collapse;
        padding: 1em 0;
        font-size: .92em;
    }
    th {
        background: #0F314A;
        border: solid 1px #ccc;
        color: #fff;
        font-weight: 600;
        padding: .5em;
    }
    tr:nth-child(even) {
        background: #f9f9f9;
    }
    td {
        padding: .5em;
    }
    td:first-child {
        text-transform: lowercase;
    }
    td.agent__name {
        text-transform: capitalize;
    }
    table th button {
        background: transparent;
        border: none;
        color: #fff;
        text-decoration: underline;
        font-weight: 600;
        cursor: pointer;
    }
    .loader-wrapper {
        background: #fff;
    }
    .loader {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 56vh;
        width: 100%;
        margin: 0 auto;
        flex-direction: column;
        align-items: center;
        text-align: center;
    }
    .loader .spinner {
        width: 50px;
        margin-bottom: 1em;
        aspect-ratio: 1;
        border-radius: 50%;
        border: 8px solid lightblue;
        border-right-color: white;
        border-left-color: white;
        animation: s2 .8s infinite linear;
    }

    @media (max-width: 992px) {

    }

    @media(max-width: 821px) {

        tr:first-child, th {
            display: none;
        }
        tr {
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            background-color: #fff !important;
            margin: 1em auto;
            box-shadow: 0 0 5px rgba(0,0,0,.3);
            padding: 1em;   
        }
        tr td:nth-child(1) {
            width: 100%;
            font-weight: 600;
        }
        tr td:nth-child(2) {
            width: 100%;
            font-weight: 600;
            padding-bottom: 0;
        }
        tr td:nth-child(3) {
            width: 100%;
        }
    }

    @keyframes s2 {to{transform: rotate(1turn)}}
</style>